module.exports = __webpack_public_path__ + "static/media/sf_1500.3e50404f85b80624bc700eb2a5ba40b2.png";